import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassEnd } from "@fortawesome/pro-duotone-svg-icons/faHourglassEnd";

export const SuspenseRequestWrapIndicator: React.FC<{}> = (props) => {
    return (
        <div className={"genie-wrap-backdrop"} style={{ position: "absolute" }}>
            <div className="genie-request-indicator__outer">
                <div className="genie-request-indicator__inner">
                    <FontAwesomeIcon size="4x" fixedWidth icon={faHourglassEnd} />
                </div>
            </div>
        </div >
    );
};

